import IDMGlobals from './../../IDMGlobals';
//
export default class APIPartitionACL {
  constructor(API) {
    this.api = API;
  }
  async listAll() {
    const req = await this.api.newBaseRequest('GET');
    req.path = IDMGlobals.APIPath_PartitionACLs;
    return await req.exec();
  }
  async create(aclObj) {
    const req = await this.api.newBaseRequest('POST');
    req.path = IDMGlobals.APIPath_PartitionACL + aclObj.id;
    req.body = {...aclObj};
    return await req.exec();
  }
  async read(aclID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = IDMGlobals.APIPath_PartitionACL + aclID;
    return await req.exec();
  }
  async update(aclObj) {
    const req = await this.api.newBaseRequest('PUT');
    req.path = IDMGlobals.APIPath_PartitionACL + aclObj.id;
    req.body = {...aclObj};
    return await req.exec();
  }
  async delete(aclID) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = IDMGlobals.APIPath_PartitionACL + aclID;
    return await req.exec();
  }
}
